<template>
  <div>
    <good-detail :no="no"></good-detail>
  </div>
</template>

<script>
import GoodDetail from './components/GoodDetail'
export default {
  components: {
    GoodDetail
  },
  data(){
    return {
      no: '',
      newData:{
        title:'11111',
        ctime:'',
        view_num:'',
        news:''
      }
    }
  },
  created() {
    this.initData()
  },
  methods: {
    initData() {
      this.no = this.$route.query.no
    },
    

  }
}
</script>

<style lang="scss" scoped>

</style>
